import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6e5e6f94&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6e5e6f94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5e6f94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e5e6f94')) {
      api.createRecord('6e5e6f94', component.options)
    } else {
      api.reload('6e5e6f94', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6e5e6f94&scoped=true&", function () {
      api.rerender('6e5e6f94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/video/index.vue"
export default component.exports